import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class StudentForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      gender: [],
      faculty: [],
      department: [],
      entry_year: [],
    },
    data: {
      tawana_id: "",
      nexa_id: "",
      student_name: "",
      student_lastname: "",
      student_father_name: "",
      student_name_en: "",
      student_lastname_en: "",
      student_father_name_en: "",
      gender: "",
      student_dob: "",
      student_email: "",
      student_phone: "",
      faculty: "",
      department: "",
      entry_year: "",
      student_photo: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { cache, edit },
    } = this.context;

    if (edit) {
      data.tawana_id = edit.tawana_id;
      data.nexa_id = edit.nexa_id;
      data.student_name = edit.student_firstname;
      data.student_lastname = edit.student_lastname;
      data.student_father_name = edit.student_father_name;
      data.student_name_en = edit.student_firstname_en;
      data.student_lastname_en = edit.student_lastname_en;
      data.student_father_name_en = edit.student_father_name_en;
      data.gender = edit.gender_id;
      data.student_dob = edit.student_dob;
      data.student_email = edit.student_email;
      data.student_phone = edit.student_phone;
      data.faculty = edit.faculty_id;
      data.department = edit.department_id;
      data.entry_year = edit.student_entry_year_id;
      data.student_photo = edit.student_photo;
    }

    await db
      .getAll(`dropdowns/genders`)
      .then(({ data: { data } }) => (drp["gender"] = data));

    await db
      .getAll(`dropdowns/faculties`)
      .then(({ data: { data } }) => (drp["faculty"] = data));

    if(data.faculty) {
      const faculty_id = data.faculty;
      await db
          .getAll(`dropdowns/departments`)
          .then(({ data: { data } }) => (drp["department"] =
              data.filter((department) => department.faculty === faculty_id)));
    }

    await db
      .getAll(`dropdowns/entryYears`)
      .then(({ data: { data } }) => (drp["entry_year"] = data));


    this.setState({ drp, data });
  };

  reloadDepartments = async (e) => {
    const { data, drp } = this.state;

    data.faculty = e.data.id
    const faculty_id = data.faculty;

    // reset old values
    data.department = null;
    drp.department = []

    await db
        .getAll(`dropdowns/departments`)
        .then(({ data: { data } }) => (drp["department"] = data.filter(
            (department) => department.faculty === faculty_id)
        ));

    this.setState({ data, drp });
  };


  schema = {
    tawana_id: Joi.number().allow(null).allow(''),
    nexa_id: Joi.string().max(16).allow(null).allow(''),
    student_name: Joi.string().max(32),
    student_lastname: Joi.string().max(32),
    student_father_name: Joi.string().max(64),
    student_name_en: Joi.string().max(32),
    student_lastname_en: Joi.string().max(32),
    student_father_name_en: Joi.string().max(64),
    gender: Joi.number(),
    student_dob: Joi.string().allow(null).allow(''),
    student_email: Joi.string().email().allow(null).allow(''),
    student_phone: Joi.string().max(14),
    faculty: Joi.number(),
    department: Joi.number().allow('').allow(null),
    entry_year: Joi.number(),
    student_photo: Joi.string().max(256).allow('').allow(null),
  };

  doSubmit = async (e) => {
    const { togglePopUp, popUp } = this.context;

    let __controls = this.cleanObject({
      student_id: popUp?.cache,
      ...this.state.data,
    });

    try {
      await db
          .form("students", e.target, __controls, popUp?.edit?.student_id)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((e) => {
            togglePopUp({
              form: "toast",
              message: e.toString(),
              type: "warning",
            });
          });
      if (popUp.callback) popUp.callback();
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { data, drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
          <form className="form crud" onSubmit={this.handleSubmit}>
              <div className="head">
                  <p>{popUp?.edit ? lbl.EditStudent : lbl.AddStudent}</p>
              </div>
            <div className="form-inputs">
              {this.renderImg("student_photo", data.student_photo)}
              <div className="multi-input">
                {this.renderInput("student_name", "اسم", "text")}
                <div className="pad"/>
                {this.renderInput("student_name_en", "Name", "text")}
              </div>
              <div className="multi-input">
                {this.renderInput("student_lastname", "تخلص", "text")}
                <div className="pad"/>
                {this.renderInput("student_lastname_en", "Last name", "text")}
              </div>
              <div className="multi-input">
                {this.renderInput("student_father_name", "اسم پدر", "text")}
                <div className="pad"/>
                {this.renderInput("student_father_name_en", "Father name", "text")}
              </div>
              <div className="multi-input">
                {this.renderSelect("faculty", "پوهنحی", drp["faculty"], false, this.reloadDepartments)}
                <div className="pad"/>
                {this.renderSelect("department", "دپارتمنت", drp["department"])}
              </div>
              <div className="multi-input">
                {this.renderSelect("entry_year", "سال ورود", drp["entry_year"])}
                <div className="pad"/>
                {this.renderInput("tawana_id", "آیدی توانا", "number")}
              </div>
              <div className="multi-input">
                {this.renderSelect("gender", "جنسیت", drp["gender"])}
                <div className="pad"/>
                {this.renderInput("student_dob", "تاریخ تولد", "date")}
              </div>
              <div className="multi-input">
                {this.renderInput("student_phone", "شماره تماس", "text")}
                <div className="pad"/>
                {this.renderInput("student_email", "ایمیل", "text")}
              </div>
              <div className="multi-input">
                {this.renderInput("nexa_id", "کد اداره ملی", "text")}
              </div>
            </div>
              <div className="form-buttons">
                  {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
              </div>
          </form>
      </div>
    );
  }
}

export default StudentForm;
